import { restClient } from '@/Core'

/** Валюта трьох сум клієнта за замовчуванням (КЛ-08, `SPEC-009` §5.1). */
export const CLIENT_DEFAULT_CURRENCY_CODE = 'EUR'

/** Валюта так, як її віддає картка валюти ядра. */
export interface CurrencyRef {
    '@id'?: string
    uuid?: string
    code?: string
    title?: string
}

let pending: Promise<CurrencyRef | null> | null = null

/**
 * Валюта за замовчуванням для форми створення клієнта:
 * `GET /services/currencies/EUR` — ядро адресує валюту кодом
 * (`SPEC-007` R-21), тож зашитих ідентифікаторів, як у легасі
 * (`DefaultValueConfig.js`), тут немає.
 *
 * Валюти немає (тенант її видалив) — `null`, поля лишаються порожніми: бек
 * зробить так само (`CrmDefaultCurrencyResolver`, `SPEC-008` §4.8).
 *
 * Один запит на сесію: валюта — довідник ядра, і за час роботи з формою вона
 * не зміниться. Невдалий запит не кешуємо — наступна форма спробує знову.
 */
export const LoadDefaultCurrencyTask = (): Promise<CurrencyRef | null> => {
    pending ??= (async () => {
        try {
            const currency = (await restClient.get(
                `/services/currencies/${CLIENT_DEFAULT_CURRENCY_CODE}`
            )) as unknown as CurrencyRef | null

            return currency && typeof currency === 'object' ? currency : null
        } catch {
            pending = null

            return null
        }
    })()

    return pending
}
